export default "<div class=\"intro\">\n\n  <div\n    [@flicker]=\"introText\"\n    class=\"intro__text\"\n  >\n    {{ introText }}\n  </div>\n\n</div>\n"